import { useQuery, useQueries } from "@tanstack/react-query";
import { getTotalGrade, getGradeTable } from "../api/moodleGradeApi";

// Lấy điểm tổng của 1 học viên
export const useHandleGrade = (userid: any, courseid?: any) => {
  const { data: userGrades, isLoading: isUserGradeLoading } = useQuery({
    queryKey: ["userGrades", userid, courseid],
    queryFn: () => courseid ? getTotalGrade(userid, courseid) : Promise.resolve(null),
    refetchOnMount: false,
    staleTime: 60000,
    enabled: !!userid && !!courseid,
  });

  return {
    userGrades,
    isUserGradeLoading
  };
};

// Sử dụng map để lấy điểm nhiều học viên
export const useHandleMultipleGrades = (userid: any, courses: Array<{ id: number }>) => {
  const gradeQueries = useQueries({
    queries: courses?.map((course) => ({
      queryKey: ["userGrades", userid, course.id],
      queryFn: () => getTotalGrade(userid, course.id),
      staleTime: 60000,
      enabled: !!userid && !!course.id,
    })) || [],
  });

  return {
    gradeQueries
  };
};

export const useGradeTable = (userid: any, courseid?: any) => {
  const { data: gradeTableData, isLoading: isGradeTableLoading } = useQuery({
    queryKey: ["gradeTable", userid, courseid],
    queryFn: () => courseid ? getGradeTable(userid, courseid) : Promise.resolve(null),
    refetchOnMount: false,
    staleTime: 60000,
    enabled: !!userid && !!courseid,
  });

  return {
    gradeTableData,
    isGradeTableLoading
  };
};

export const useMultipleGradeTables = (userid: any, courses: Array<{ id: number }>) => {
  const gradeTableQueries = useQueries({
    queries: courses?.map((course) => ({
      queryKey: ["gradeTable", userid, course.id],
      queryFn: () => getGradeTable(userid, course.id),
      staleTime: 60000,
      enabled: !!userid && !!course.id,
    })) || [],
  });

  return {
    gradeTableQueries
  };
};
